<script>
    import {onMount} from "svelte";

    export let user;

    let showMobileMenu = false;
    let smallWindow = window.innerWidth < 767;

    function isEmpty(str) {
        return (!str || str.length === 0 );
    }

    const handleMobileIconClick = () => (showMobileMenu = !showMobileMenu);

    const mediaQueryHandler = e => {
        if (!e.matches) {
            showMobileMenu = false;
        }
    };

    const reportWindowSize = e => {
        smallWindow = window.innerWidth < 767;
    }

    onMount(() => {
        const mediaListener = window.matchMedia("(max-width: 767px)");
        mediaListener.addEventListener("window-size",mediaQueryHandler);
        window.addEventListener('resize', reportWindowSize);
    });
</script>

<nav>
    <div class="inner">
        <logo-text><a href="/">{smallWindow ? 'K' : 'Kulrs'}</a></logo-text>
        <div on:click={handleMobileIconClick} class={`mobile-icon${showMobileMenu ? ' active' : ''}`}>
            <div class="middle-line"></div>
        </div>
        <ul class={`navbar-list${showMobileMenu ? ' mobile' : ''}`}>
            <li>
                {#if $user}
                    <a href='/'>Favorites</a>
                    <a href='#/logout'>Logout</a>
                {:else}
                    <a href='#/login'>Login</a>
                {/if}
            </li>
        </ul>
    </div>
</nav>

<style>
    nav {
        position: fixed;
        top: 0;
        width: 100%;
        background-color: #202020;
        height: 6vh;
    }

    .inner {
        padding-left: 2vw;
        padding-right: 2vw;
        display: flex;
        align-items: center;
        height: 100%;
    }

    logo-text {
        font-family: 'Monoton', monospace;
        color: #AAFFDD;
        font-size: 3vh;
        margin-right: 2vw;
    }
    logo-text a {
        color: #AAFFDD;
        font-size: 3vh;
        text-decoration: none;
        display: flex;
        height: 45px;
        align-items: center;
        padding: 0 10px;
    }

    nav-logo .img {
        height: 5vh;
    }

    .mobile-icon {
        width: 25px;
        height: 14px;
        position: relative;
        cursor: pointer;
    }

    .mobile-icon:after,
    .mobile-icon:before,
    .middle-line {
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        background-color: #fff;
        transition: all 0.4s;
        transform-origin: center;
    }

    .mobile-icon:before,
    .middle-line {
        top: 0;
    }

    .mobile-icon:after,
    .middle-line {
        bottom: 0;
    }

    .mobile-icon:before {
        width: 66%;
    }

    .mobile-icon:after {
        width: 33%;
    }

    .middle-line {
        margin: auto;
    }

    .mobile-icon:hover:before,
    .mobile-icon:hover:after,
    .mobile-icon.active:before,
    .mobile-icon.active:after,
    .mobile-icon.active .middle-line {
        width: 100%;
    }

    .mobile-icon.active:before,
    .mobile-icon.active:after {
        top: 50%;
        transform: rotate(-45deg);
    }

    .mobile-icon.active .middle-line {
        transform: rotate(45deg);
    }

    .navbar-list {
        display: none;
        width: 100%;
        justify-content: right;
        font-family: "Poppins", "Arial", "Helvetica Neue", sans-serif;

        font-size: 2.5vh;
        margin: 0;
        padding: 0 40px;
    }

    .navbar-list.mobile {
        background-color: rgba(0, 0, 0, 0.8);
        position: fixed;
        display: block;
        height: calc(100% - 6vh);
        bottom: 0;
        left: 0;
    }

    .navbar-list li {
        list-style-type: none;
        position: relative;
    }

    .navbar-list a {
        color: #F4EAEF;
        text-decoration: none;
        display: flex;
        height: 45px;
        align-items: center;
        padding: 0 10px;
    }


    @media only screen and (min-width: 767px) {
        .mobile-icon {
            display: none;
        }
        .navbar-list {
            display: flex;
            padding: 0;
        }
        .navbar-list a {
            display: inline-flex;
        }
    }
</style>